export default "__VITE_ASSET__BbBcWglx__"